export default __webpack_public_path__ + "static/media/joker1.706eefd0.jpg";